import React from 'react';
import "./Checkout.css";
import CheckoutProduct from './CheckoutProduct';
import { getBasketTotal } from './reducer';
import { useStateValue } from './StateProvider';
import Subtotal from './Subtotal';
function Checkout() {
    
    const [{basket,user},dispatch]=useStateValue();
    return (
        <div className="checkout">
            <div className="checkout__left">
                <img className="checkout__ad"
                src="https://images-na.ssl-images-amazon.com/images/G/02/UK_CCMP/TM/OCC_Amazon1._CB42349266B_.jpg"
                alt=""/>
                <h3>Hello, {user.email}</h3>
                <div>
                    
                    <h2 className="checkout__title">Your shopping Basket</h2>
                      {/* CheckoutProducts */} 
                    {basket.map(item=>(
                        <CheckoutProduct 
                        id={item.id}
                        title={item.title}
                        image={item.image}
                        price={item.price}
                        rating={item.rating}></CheckoutProduct>
    ))}                 
                </div>
            </div>
            <div className="checkout__right">
                <Subtotal/>
            </div>
        </div>
    )
}

export default Checkout
